import { render, staticRenderFns } from "./FormMasterProduct.vue?vue&type=template&id=8a47ede4"
import script from "./FormMasterProduct.vue?vue&type=script&lang=js"
export * from "./FormMasterProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormMasterProduct.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports